import { useGetBookingPaymentQuery } from "../store/api/adminApi";
export default function BookingPaymentStatus({ booking, kind = "booking" }) {
  const { data, isError } = useGetBookingPaymentQuery(
    { kind, id: booking.id },
    {
      skip: !booking.paymentRequired,
      pollingInterval: 10000,
      skipPollingIfUnfocused: true,
    },
  );
  if (!booking.paymentRequired) return null;
  const payment = data?.data;
  return (
    <div className="rounded-xl bg-primary/5 border border-primary/20 p-4 my-3 text-left">
      <p className="font-manrope-semibold text-sm text-black">
        {payment?.needsReview
          ? "Payment needs review"
          : payment?.status === "paid" || booking.paymentStatus === "paid"
            ? "Payment verified"
            : "Awaiting customer payment"}
      </p>
      <p className="font-manrope-regular text-xs text-secondary mt-1">
        {isError
          ? "Unable to load payment details. Refresh to try again."
          : "Approval happens automatically after Fygaro verifies payment."}
      </p>
      {payment?.amount && (
        <p className="font-manrope-semibold text-primary text-sm mt-2">
          {payment.currency} {Number(payment.amount).toFixed(2)}
        </p>
      )}
      {payment?.transactionId && (
        <p className="text-xs text-secondary mt-1 break-all">
          Transaction: {payment.transactionId}
        </p>
      )}
      {payment?.needsReview && (
        <p className="text-xs text-red-600 mt-2">
          Funds were received but the booking could not be approved. Review it
          in Fygaro before taking further payment.
        </p>
      )}
    </div>
  );
}
